import InactiveRow from "./InactiveRow";
import InactiveCellRenderer from "../renderers/InactiveCellRenderer";

export default class DisabledUsersSeparateRow extends InactiveRow {
    constructor(isFirstRow) {
        super();
        this.separateCellRenderer = new InactiveCellRenderer();
        this.separateCellRenderer.getLastCellRightBorderClassName = function() { return "lockTableRightBorder"; };
        if (isFirstRow)
            this.groupCell.style.borderTop = "none";
    }

    createRowHeaderRenderer() {
        return new InactiveCellRenderer("disabledUserSeparatorHeader");
    }

    createLockCellRenderer() {
        return this.separateCellRenderer;
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/DisabledUsersSeparateRow.js